import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dropdown, Form } from 'semantic-ui-react';

import cm from 'helpers/commons';
import * as cm_action from 'actions/commons';

const propTypes = {};

const defaultProps = {};

class PresetList extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { defaultValue } = this.props;

    if (defaultValue) {
      const data = {
        value: defaultValue
      };
      this.presetSelect(null, data);
    }
  }

  presetSelect = (e, data) => {
    const { commonFn } = this.props;

    commonFn.changePreset({
      type: 'preset',
      name: 'value',
      value: data.value === 0 ? null : data.value
    });
  };

  render() {
    const { presetList, inputStyle, preset, defaultValue, presetType } = this.props;
    const defaultOptions = [{ value: '0', text: '권한 목록 ' }];
    let presetListData = null;
    let presetTemp = [];

    if (presetList && presetList.data) {
      if (presetType) {
        presetList.data.forEach((data, idx) => {
          if (data.type === presetType) {
            presetTemp.push(data);
          }
        });
      } else {
        presetTemp = presetList.data;
      }

      presetListData = cm.selectDataForMat(presetTemp, '-', 'preset');
    }

    return (
      <Form.Field inline className="com-preset">
        {presetListData ? (
          <Dropdown
            placeholder="권한 목록"
            selection
            style={inputStyle}
            value={preset && preset.value ? preset.value : defaultValue}
            options={presetListData}
            onChange={this.presetSelect}
          />
        ) : (
          <Dropdown
            placeholder="권한 목록"
            selection
            disabled
            style={inputStyle}
            defaultValue={0}
            options={defaultOptions}
          />
        )}
      </Form.Field>
    );
  }
}

PresetList.propTypes = propTypes;
PresetList.defaultProps = defaultProps;

PresetList = connect(
  (state) => ({
    preset: state.commons.preset,
    presetList: state.commons.presetList
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changePreset: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(PresetList);

export default PresetList;
